import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["variant", "$css", "placeholder", "label", "htmlFor", "hiddenLabel", "id", "disabled", "step", "children", "required"];
import React from 'react';
import styled, { css } from 'styled-components';
import { VisuallyHidden } from '@figure/frontlib-accessibility';
import { COLORS, TYPOGRAPHY } from '../../../themes';
import { IS_DEV } from '../../../constants';
import { Span, StyledLabel } from '../../Styled';
import { flex } from '../../../styling';
import { HelperText } from '../../text';
export var labelCss = /*#__PURE__*/css(["", " color:", ";"], function (_ref) {
  var $variant = _ref.$variant;
  return $variant === 'secondary' ? TYPOGRAPHY.M_SEMIBOLD : TYPOGRAPHY.H6;
}, function (_ref2) {
  var $variant = _ref2.$variant,
      $disabled = _ref2.$disabled;
  return $disabled ? COLORS.NEUTRAL_300 : $variant === 'secondary' ? COLORS.NEUTRAL_500 : COLORS.NEUTRAL_600;
});
var LabelSpan = /*#__PURE__*/styled.span.withConfig({
  displayName: "Label__LabelSpan",
  componentId: "sc-1af6nrv-0"
})(["", ";"], labelCss);

var Label = function Label(_ref3) {
  var _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'primary' : _ref3$variant,
      $css = _ref3.$css,
      placeholder = _ref3.placeholder,
      label = _ref3.label,
      htmlFor = _ref3.htmlFor,
      hiddenLabel = _ref3.hiddenLabel,
      id = _ref3.id,
      disabled = _ref3.disabled,
      step = _ref3.step,
      children = _ref3.children,
      required = _ref3.required,
      rest = _objectWithoutProperties(_ref3, _excluded);

  if (IS_DEV && !placeholder && !label && !hiddenLabel) console.error("Label for ".concat(htmlFor, " needs a label or placeholder."));
  return label ? /*#__PURE__*/React.createElement(StyledLabel, _extends({
    $css: css(["user-select:none;", " ", ""], flex('flex-start', 'flex-start'), $css),
    htmlFor: htmlFor,
    id: id
  }, rest), typeof step !== 'undefined' && /*#__PURE__*/React.createElement(Span, {
    className: "step-container",
    $css: css(["width:2rem;height:2rem;border-radius:50%;margin-right:8px;margin-top:2px;flex:0 0 auto;background:", ";", " > span{", ";line-height:1;color:", ";transform:translateY(1px);}"], disabled ? COLORS.NEUTRAL_300 : COLORS.NEUTRAL_600, flex(), TYPOGRAPHY.XS_BOLD, COLORS.WHITE)
  }, /*#__PURE__*/React.createElement("span", null, step)), /*#__PURE__*/React.createElement(Span, {
    $css: css(["display:block;"]),
    className: "label-container"
  }, /*#__PURE__*/React.createElement(LabelSpan, {
    className: "label",
    $variant: variant,
    $disabled: disabled
  }, label, required && '*'), children && /*#__PURE__*/React.createElement(HelperText, {
    disabled: disabled,
    className: "description",
    $css: css(["margin-top:8px;"])
  }, children))) : /*#__PURE__*/React.createElement(VisuallyHidden, {
    as: "label",
    htmlFor: htmlFor,
    id: id
  }, placeholder || hiddenLabel);
};

export default Label;